<script>
    import { mapActions, mapGetters } from "vuex";
    import FHeader from "@/components/FHeader";
    import FFooter from "@/components/FFooter";

    export default {
        data: () => ({
            dark: false,
            online: navigator.onLine
        }),

        components: { FHeader, FFooter },

        mounted() {
            window.addEventListener("online", this.networkChange);
            window.addEventListener("offline", this.networkChange);

            try {
                this.dark = JSON.parse(localStorage.getItem("@fluid/dark"));

                const keep = JSON.parse(
                    localStorage.getItem("@fluid/keep") || "false"
                );

                const metaThemeColor = document.querySelector(
                    "meta[name=theme-color]"
                );

                metaThemeColor.setAttribute(
                    "content",
                    this.dark ? "#000" : "#063e5f"
                );

                if (!keep) this.signOut() && this.$router.push("/login");
            } catch (e) {}
        },

        beforeDestroy() {
            window.removeEventListener("online", this.networkChange);
            window.removeEventListener("offline", this.networkChange);
        },

        methods: {
            ...mapActions(["signOut"]),
            toggleTheme() {
                const metaThemeColor = document.querySelector(
                    "meta[name=theme-color]"
                );

                this.dark = !this.dark;

                metaThemeColor.setAttribute(
                    "content",
                    this.dark ? "#000" : "#063e5f"
                );

                localStorage.setItem("@fluid/dark", this.dark);
            },

            networkChange() {
                this.online = !this.online;
            }
        },

        computed: {
            ...mapGetters(["loading"]),

            renderUi() {
                return !this.$route.path.includes("login");
            }
        }
    };
</script>

<template>
    <v-app :dark="dark">
        <FHeader
            v-if="renderUi"
            :isDarkThemeActive="dark"
            :tipoModulo="0"
            @toggle-theme="this.toggleTheme"
        />

        <v-content>
            <div
                :class="{'__offline': !online, '__offline--login': !renderUi}"
                class="fluid__offline"
            >Sem conexão com a internet</div>
            <router-view :class="{'app--loading': loading}"/>
        </v-content>

        <FFooter
            v-if="renderUi"
            :renderMenuIcon="true"
            companyName="Posto de Exemplo com Nome Grande"
        />
    </v-app>
</template>

<style>
    .theme--light.application .content {
        background-color: #f9f9f9;
    }

    /* override */
    .theme--dark.application .apexcharts-legend-text {
        color: #fff !important;
    }

    .fluid__offline {
        height: 20px;
        background: red;
        width: 100vw;
        color: white;
        display: flex;
        justify-content: center;
        font-weight: 700;
        align-items: center;
        transition: all 0.5s ease;
        transform: scale(0);
        position: fixed;
        z-index: 9;
        bottom: 4vh;
        opacity: 0;
        font-size: 0.89rem;
    }

    .__offline--login {
        bottom: 0;
        height: 30px;
    }

    .__offline {
        opacity: 1;
        transform: scale(1);
    }

    .app--loading {
        opacity: 0.2;
        pointer-events: none;
    }

    @media only screen and (min-width: 700px) {
        .fluid__desk_container section {
            display: flex;
            margin-top: 25px;
        }
        .fluid__chart--pie {
            margin: 0 !important;
        }
    }
</style>

